function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-564-566h1920v2651H-564z"
}), React.createElement("path", {
  d: "M-565-259h1920v2286H-565z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  d: "M106.094 61.053c15.101 0 27.344 12.243 27.344 27.344 0 15.102-12.243 27.344-27.344 27.344-15.102 0-27.344-12.242-27.344-27.344 0-15.101 12.242-27.344 27.344-27.344zm0 2.188c-13.894 0-25.156 11.263-25.156 25.156 0 13.894 11.262 25.156 25.156 25.156 13.893 0 25.156-11.262 25.156-25.156 0-13.893-11.263-25.156-25.156-25.156zm0 8.75c9.06 0 16.406 7.345 16.406 16.406s-7.345 16.406-16.406 16.406-16.406-7.345-16.406-16.406c0-9.06 7.345-16.406 16.406-16.406zm0 2.187c-7.853 0-14.219 6.366-14.219 14.22 0 7.852 6.366 14.218 14.219 14.218s14.219-6.366 14.219-14.219-6.366-14.219-14.22-14.219z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 74.008,
  y: 138.719
}, "Zraszacz")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pivot.b1ac63d7.svg";
export { SvgComponent as ReactComponent };